export class URLTrailingSlash extends URL {
  constructor(url: string | URL, base?: string | URL) {
    super(url, base);

    // NOTE:
    // Add trailing slash to URLs:
    // https://a.com -> https://a.com/
    if (!this.pathname.endsWith("/")) {
      this.pathname = `${this.pathname}/`;
    }
  }
}
